import React from "react"

import type { EditableTestCase } from "../../../model"
import { KnowledgeBaseEntries } from "./KnowledgeBaseEntries"
import { useGridCell } from "./useGridCell"

interface TestCaseKbEntriesCellProps {
  testCase: EditableTestCase
  isExpanded: boolean
  width: string
}

export const TestCaseKbEntriesCell: React.FC<TestCaseKbEntriesCellProps> = ({
  testCase,
  isExpanded,
  width,
}) => {
  const { cellProps } = useGridCell({
    ariaLabel: "Knowledge base entries",
    portalAware: true,
  })

  const kbEntries = testCase.connected_knowledge_base_entries || []
  const hasKbEntries = kbEntries.length > 0

  return (
    <td
      {...cellProps}
      className="p-0 outline-none"
      style={{ width, padding: 0, verticalAlign: "top" }}
    >
      <div className="px-2 pt-4 pb-2 flex flex-col">
        {!hasKbEntries && !isExpanded ? (
          <span className="text-sm text-coval-text-muted select-none">
            No KB entries
          </span>
        ) : (
          <KnowledgeBaseEntries testCase={testCase} isExpanded={isExpanded} />
        )}
      </div>
    </td>
  )
}
